
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mkpl/category/[...slug]",
      function () {
        return require("private-next-pages/mkpl/category/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mkpl/category/[...slug]"])
      });
    }
  